import { useEffect } from 'react';
import { Dialog } from '@/components/ui/dialog';

/**
 * Enhanced Dialog component that resets scroll position when opened
 * Use this instead of the regular Dialog component when you want to ensure
 * the dialog is centered regardless of page scroll position
 */
interface DialogWithScrollResetProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
  [key: string]: any; // For any other props
}

export function DialogWithScrollReset({
  open,
  onOpenChange,
  children,
  ...props
}: DialogWithScrollResetProps) {
  // Reset scroll position when dialog opens
  useEffect(() => {
    if (open) {
      // Reset scroll position
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange} {...props}>
      {children}
    </Dialog>
  );
}

export default DialogWithScrollReset;